import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { agentPasswordSettingsOptions } from './password-settings.options'
import { setAgentPasswordSettings } from './password-settings.service'
import type { AgentSetPasswordSettingsInput } from '../..'

export const useAgentPasswordSettings = (enabled = true) => {
  return useQuery(agentPasswordSettingsOptions(enabled))
}

export const useSetAgentPasswordSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: AgentSetPasswordSettingsInput) =>
      setAgentPasswordSettings(data),
    onSuccess: () => {
      // Invalidate and refetch agent password settings after successful update
      queryClient.invalidateQueries({ queryKey: ['agent-password-settings'] })
    },
  })
}
